module.exports = __webpack_public_path__ + "static/tikoy-cd5a1490fd2c35699c68603e89402958.jpg";